module.exports = __webpack_public_path__ + "static/media/TOH.ee7421b3.png";